export const citySlug = (city) => (city || "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
export const fold = (s) => (s || "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

// Aviasales Hotels has no deep-linkable listings page, so its cards land on our city stay planner instead.
export const isSearchOnlyHotel = (item) =>
  item?.travel_type === "Hotel" && /aviasales hotels/i.test(item?.provider || "") && !!item?.destination;

export const checkedAgo = (iso) => {
  const h = Math.floor((Date.now() - new Date(iso).getTime()) / 3600_000);
  return h < 1 ? "under 1h ago" : `${h}h ago`;
};

export const checkinLabel = (d) => (d ? new Date(`${d}T12:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric" }) : "");

export const cityStayPath = (item) => `/travel/${citySlug(item.destination)}?stay=1`;
